import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import Close from '../assets/Close.png';
import SupportIcon from '../assets/Support.svg';
import WhatsappIcon from '../assets/WhatsApp.png';
import SupportPhone from '../assets/SupportPhone.png';
import TagManager from 'react-gtm-module';
import Arrow from '../assets/arrow-up.png';
import ContactInfo from './ContactInfo';
import { useTranslation } from 'react-i18next';
import { useRTL } from '../hooks/useRTL';

const Support = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [phoneIconOpacity, setPhoneIconOpacity] = useState(0.6);
  const [arrowIconOpacity, setArrowIconOpacity] = useState(0.6);
  const [mobile, setMobile] = useState(false);
  const [showContactInfo, setShowContactInfo] = useState(false);
  const [arrowVisible] = useState(false);
  const { i18n } = useTranslation();
  const isRTL = useRTL();

  const gtmId = 'GTM-T4QRDGLB';
  const initializeTagManager = () => {
    TagManager.initialize({ gtmId });
  };

  const toggleModal = () => {
    setIsOpen(!isOpen);
  };

  const openPhoneDialer = () => {
    window.open('tel:+96176624565');
  };

  const isMobile = () => {
    return /android|ipad|iphone|ipod|windows phone/i.test(navigator.userAgent);
  };

  const openContactInfo = () => {
    setShowContactInfo(!showContactInfo);
    setIsOpen(true);
  };

  const closeContactInfo = () => {
    setShowContactInfo(false);
    setIsOpen(false);
  };

  useEffect(() => {
    document.documentElement.dir = isRTL ? 'rtl' : 'ltr';
  }, [isRTL]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const x = params.get('lang');
    if (x === 'ar') {
      i18n.changeLanguage('ar');
      document.documentElement.dir = 'rtl';
    } else {
      i18n.changeLanguage('en');
      document.documentElement.dir = 'ltr';
    }
  }, [i18n]);

  useEffect(() => {
    initializeTagManager();
    setMobile(isMobile());
  }, [mobile]);

  return (
    <>
      {showContactInfo && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            backdropFilter: 'blur(5px)',
            zIndex: 4,
          }}
        />
      )}

      <ContactInfo
        show={showContactInfo}
        onClose={closeContactInfo}
        style={{ zIndex: 999 }}
      />

      <div
        style={{
          position: 'fixed',
          bottom: 50,
          right: 20,
          zIndex: 99,
        }}
        className={`${isRTL ? 'rtl' : 'ltr'}`}>
        <motion.div
          style={{
            position: 'relative',
            height: 45,
            width: 45,
            cursor: 'pointer',
            marginBottom: 10,
            backgroundColor: '#008a80',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            opacity: phoneIconOpacity,
          }}
          onClick={toggleModal}
          initial={{ scale: 1, opacity: 0.6 }}
          whileHover={{ scale: 1.1, opacity: 1 }}
          whileTap={{ scale: 0.9, opacity: 1 }}>
          {isOpen ? (
            <motion.img
              key='close-icon'
              src={Close}
              style={{
                objectFit: 'contain',
                width: 32,
                height: 32,
                color: 'white',
                opacity: 1,
              }}
              alt='close-icon'
              initial={{ opacity: 1 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
            />
          ) : (
            <motion.img
              key='support-icon'
              src={SupportIcon}
              style={{
                objectFit: 'contain',
                width: 32,
                height: 32,
                color: 'white',
              }}
              alt='support-icon'
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
            />
          )}
        </motion.div>

        {isOpen && (
          <motion.div
            key='hover-circles'
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0 }}
            style={{
              position: 'absolute',
              top: -100,
              left: '-85%',
              transform: 'translateX(-50%)',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              width: 120,
            }}>
            {mobile ? (
              <motion.div
                style={{
                  width: 40,
                  height: 40,
                  backgroundColor: 'rgba(0, 138, 128, 0.5)',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: 10,
                  opacity: 1,
                }}
                onClick={() => {
                  setPhoneIconOpacity(1);
                  openPhoneDialer();
                }}
                whileHover={{ scale: 1.1, opacity: 1 }}
                whileTap={{ scale: 0.9, opacity: 1 }}>
                <img
                  src={SupportPhone}
                  style={{
                    width: '50%',
                    height: '50%',
                    zIndex: '999',
                  }}
                  alt='phone'
                />
              </motion.div>
            ) : (
              <motion.div
                style={{
                  width: 40,
                  height: 40,
                  backgroundColor: 'rgba(0, 138, 128, 0.5)',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: 10,
                  opacity: 1,
                }}
                onClick={() => {
                  openContactInfo();
                }}
                whileHover={{ scale: 1.1, opacity: 1 }}
                whileTap={{ scale: 0.9, opacity: 1 }}>
                <img
                  src={SupportPhone}
                  style={{
                    width: '50%',
                    height: '50%',
                    zIndex: '999',
                  }}
                  alt='phone'
                />
              </motion.div>
            )}
            <motion.div
              style={{
                width: 40,
                height: 40,
                backgroundColor: '#00B100',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                opacity: 1,
              }}
              onClick={() => window.open('https://wa.me/96176624565', '_blank')}
              whileHover={{ scale: 1.1, opacity: 1 }}
              whileTap={{ scale: 0.9, opacity: 1 }}>
              <img
                src={WhatsappIcon}
                style={{
                  objectFit: 'contain',
                  width: '80%',
                  height: '80%',
                  color: 'white',
                }}
                alt='whatsapp'
              />
            </motion.div>
          </motion.div>
        )}

        {arrowVisible && (
          <motion.div
            onClick={() => {
              window.scrollTo({ top: 0, behavior: 'smooth' });
              setArrowIconOpacity(1);
            }}
            style={{
              height: 45,
              width: 45,
              cursor: 'pointer',
              marginTop: 10,
              opacity: arrowIconOpacity,
              transition: 'opacity 0.3s ease',
            }}
            whileHover={{ scale: 1.1, opacity: 1 }}
            whileTap={{ scale: 0.9, opacity: 1 }}
            id='ArrowIcon'>
            <img
              src={Arrow}
              style={{
                objectFit: 'contain',
                width: '100%',
                height: '100%',
              }}
              alt='arrow-up'
            />
          </motion.div>
        )}
      </div>
    </>
  );
};

export default Support;
